var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var actions = require('../../../modules/newsletter/actions/newsletter');
var downloadActions = require( '../../../modules/meta/actions/appDownload-click');
var letestScoreActions = require( '../../../modules/latestScore/actions/latestScore');
var surveyMetaActions = require('../../../modules/meta/actions/survey');
var authLoginActions = require('../../../modules/auth/actions/auth-login');
var authActions = require('../../../modules/auth/actions/auth-register');
var Home = require('../components/home.jsx');

  var mapStateToProps = function(state){
    return {
      newsletter: state.newsletter,
      auth: state.auth,
      latestScore: state.latestScore.data
    };
  }

  var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, actions, downloadActions, letestScoreActions, surveyMetaActions, authLoginActions, authActions), dispatch);
  }

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/common/routes/home/containers/home.jsx